<template>
  <!-- 地块需求列表 -->
  <div class="requirement-list">
    <div class="requirement-item" v-for="(item, i) in list" :key="i" @click="onDetail(item)">
      <div class="title">{{ item.title }}</div>
      <div class="info">
        <div class="info-left">
          <!-- <div>
            <span class="lable">
              <view class="iconfont icon-address"></view>
              地址：
            </span>
            {{ item.address }}
          </div> -->
          <div>
            <span class="lable">
              <view class="iconfont icon-land-use"></view> 土地用途：
            </span>{{ item.use_type_name }}
          </div>
          <div>
            <span class="lable">
              <view class="iconfont icon-release-time"></view> 发布时间：
            </span>{{ timeProcessing(item.created_at,2) }}
          </div>
        </div>
        <div class="info-right">
          <div>
            <span class="lable">
              <view class="iconfont icon-area1"></view> 需求面积：
            </span>{{ item.area }}㎡
          </div>
          <div>
            <span class="lable">
              <view class="iconfont icon-age-limit"></view> {{ isBuy ? '使用' : '租赁' }}年限：
            </span>{{ item.year }}年
          </div>
        </div>
      </div>
      <div class="price">
        <div class="text">{{ isBuy ? '求购价' : '求租价' }}</div>
        <div class="num">{{ item.price == 0 ? '面议' : `${item.price}万元` }}</div>
      </div>
    </div>
    <!-- 数据为空 -->
    <el-empty v-if="list.length <= 0" style="width: 100%;" description="暂无数据" />
  </div>
</template>

<script setup>
import router from "@/router";
import { reactive, computed, defineProps } from "vue";
import { timeProcessing } from "@/utils/time";


const props = defineProps({
  //子组件接收父组件传递过来的值
  list: Array,
  isBuy: Boolean
})

// 根据接收不同状态显示不同背景颜色
const activation = computed((activation) => {
  return (state) => {
    // console.log(state)
    if (state === "交易中") {
      return {
        background: "#349BF9",
      };
    } else {
      return {
        background: "#F93434",
      };
    }
  };
});
const boxes = reactive([]);
const onDetail = (val) => {
  router.push(`/land-demand-detail?id=${val.id}`)
}
</script>

<style scoped lang="less">
.requirement-list {
  background: #fff;

  .requirement-item {
    padding: 1.25rem;
    position: relative;
    cursor: pointer;

    .title {
      font-size: 1.375rem;
      color: #333333;
    }

    .info {
      display: flex;
      margin-top: 1.375rem;

      div {
        div {
          font-size: 0.75rem;
          color: #333333;
          margin-top: 0.625rem;

          .lable {
            color: #999999;

            .iconfont {
              font-size: 0.857rem;
              margin-right: 0.357rem;
            }

            .icon-age-limit {
              font-size: 1rem;
            }
          }
        }
      }

      .info-right {
        margin-left: 7.187rem;
      }
    }

    .price {
      position: absolute;
      top: 3.062rem;
      right: 5rem;
      text-align: center;

      .text {
        /* 求购价 */
        font-size: 1rem;
        color: #999999;
      }

      .num {
        font-size: 1.375rem;
        font-weight: bold;
        color: #F93434;
        margin-top: 0.625rem;
      }
    }
  }
  .requirement-item:hover{
    .title{
      color: #349bf9;
    }
  }
}
</style>
